<template>
	<div class="energyBox">
		<div class="banner">
			<div class="txt">能源板块</div>
		</div>
		<div class="desBox">
			<div class="name">张家口智算中心绿电消纳试点项目一期200MW风电项目</div>
			<div class="tip">工程场址位于河北省张家口市万全区境内</div>
			<ul class="list flexBox">
				<li>
					<p class="txt">本工程风电场规划容量为</p>
					<p class="val"><span>200</span>MW</p>
				</li>
				<li>
					<p class="txt">拟建设风电机组</p>
					<p class="val"><span>32</span>台</p>
				</li>
				<li>
					<p class="txt">单机容量为</p>
					<p class="val"><span>6.25</span>MW</p>
				</li>
			</ul>
			<div class="des">
				在算力中心建设和配套新能源建设基础上,构建绿电直供框架下的算电协同一体化调度平台，平台以自研能源大模型为底座，实现算力侧、电力侧、园区侧、网络侧四向联动智能调度，配套的风光储和变电站进行集中监控，实现智算场景下能源与算力全链路的数据穿透及流程整合，做到<span>“算”随“电”动、“电”随“算”用</span>的整体协同。
			</div>
		</div>
		<div class="infoBox">
			<div class="name">中明人工智能算电基地——清洁能源基地</div>
			<ul class="tag">
				<li class="flexBox">
					<i></i>
					<p class="txt">由风光水火气储超大规模可再生能源项目为支撑</p>
				</li>
				<li class="flexBox">
					<i></i>
					<p class="txt">探索实践算力和绿色电力“双力一体化”产业路径</p>
				</li>
			</ul>
			<div class="tip">清洁能源基地分布在张家口坝上区域</div>
			<ul class="list flexBox">
				<li>
					<p class="txt">规划占地约</p>
					<p class="val"><span>1000</span>亩</p>
				</li>
				<li>
					<p class="txt">新能源总建设容量为</p>
					<p class="val"><span>5000</span>MW</p>
				</li>
				<li>
					<p class="txt">风电建设容量为</p>
					<p class="val"><span>3500</span>MW</p>
				</li>
				<li>
					<p class="txt">光伏建设容量为</p>
					<p class="val"><span>1500</span>MW</p>
				</li>
			</ul>
			<div class="des">
				年消纳绿电量约<span>104</span>亿kWh绿电，绿电占比超<span>80</span>%，<br>
				配套建设<span>1000</span>MW/<span>2000</span>MWh构网型储能系统和<span>220</span>kV电压等级的输变电工程。
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Energy',
		components: {

		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/energy.css");
</style>